import { useMutation } from "react-query";
import api from "../../client";
import { DetailResponseData } from "../../types/base";
import { AuthRegistrationPayload } from "../../types/auth";

const postData = async (
  payload: AuthRegistrationPayload,
): Promise<DetailResponseData<object>> => {
  const { data } = await api.post(`/auth/register`, payload);

  return data;
};

export const useRegistration = () => {
  return useMutation((payload: AuthRegistrationPayload) => {
    return postData(payload);
  });
};
